import {
  CraftnoteEvent,
  createCraftnoteEventBuilder,
  GlobalCraftnoteEventParameters
} from "./CraftnoteEvent.generated";
/**
* Container for all events for Search
*
*
* this file was auto-generated Craftnote Events Code Generator, for more info visit: https://github.com/craftnote/craftnote-events
*/
export type SearchParameters = SearchSettingsExecutedParameters | SearchScreenOpenedParameters | SearchSearchExecutedParameters | SearchItemOpenedParameters | SearchUpgradeSelectedParameters;
export type SearchEvents = SearchSettingsExecutedEvent | SearchScreenOpenedEvent | SearchSearchExecutedEvent | SearchItemOpenedEvent | SearchUpgradeSelectedEvent;

export interface SearchSettingsExecutedParameters {
	searchTerm: string; // text used in the search settings input
	result: string; // possible values are, 'hasNoResults' if there is no result or clicked menu item like 'profile' | 'notification-channels' | 'company-settings' | 'company-employees' | 'company-templates' | 'subscription' | 'api-keys' | 'company-projects' | 'project-status' | 'archive' | 'restorable-projects' | 'support' | 'explanatory-video' | 'app-settings' | 'language' | 'gallery-setting' | 'wifi-setting' | 'data-protection' | 'toc' | 'imprint' | 'manage-account' | 'empty-cache'
}

export type SearchSettingsExecutedParametersSpecific = Omit<
	SearchSettingsExecutedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const searchSettingsExecutedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = [];

export class SearchSettingsExecutedEventBuilder {
	constructor(private specificParameters: SearchSettingsExecutedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<SearchSettingsExecutedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			SearchSettingsExecutedParametersSpecific,
            SearchSettingsExecutedParameters,
			(params: SearchSettingsExecutedParameters) => SearchSettingsExecutedEvent
		>(this.specificParameters, searchSettingsExecutedParametersGlobal, globalParams, (params) => new SearchSettingsExecutedEvent(params));
	}
}

/**
 * A user executed a search within settings.
 */
export class SearchSettingsExecutedEvent extends CraftnoteEvent<SearchSettingsExecutedParameters>{
  constructor(parameters: SearchSettingsExecutedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "search_settings_executed"
		},
	]);
  }
}
export interface SearchScreenOpenedParameters {
	version: string; // version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
}

export type SearchScreenOpenedParametersSpecific = Omit<
	SearchScreenOpenedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const searchScreenOpenedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class SearchScreenOpenedEventBuilder {
	constructor(private specificParameters: SearchScreenOpenedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<SearchScreenOpenedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			SearchScreenOpenedParametersSpecific,
            SearchScreenOpenedParameters,
			(params: SearchScreenOpenedParameters) => SearchScreenOpenedEvent
		>(this.specificParameters, searchScreenOpenedParametersGlobal, globalParams, (params) => new SearchScreenOpenedEvent(params));
	}
}

/**
 * A user opened the global search screen.
 */
export class SearchScreenOpenedEvent extends CraftnoteEvent<SearchScreenOpenedParameters>{
  constructor(parameters: SearchScreenOpenedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "search_screen_opened"
		},
		{
			name: "iterable",
			eventName: "search_screen_opened"
		},
	]);
  }
}
export interface SearchSearchExecutedParameters {
	version: string; // version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
	preScope: string; // search pre scope (filter) of the global search, possible values are "none", "projects-all", "projects-active", "projects-archived", "folders-all", "folders-active", "folders-archived", "messages", "tasks-all", "tasks-open", "tasks-completed"
}

export type SearchSearchExecutedParametersSpecific = Omit<
	SearchSearchExecutedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const searchSearchExecutedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class SearchSearchExecutedEventBuilder {
	constructor(private specificParameters: SearchSearchExecutedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<SearchSearchExecutedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			SearchSearchExecutedParametersSpecific,
            SearchSearchExecutedParameters,
			(params: SearchSearchExecutedParameters) => SearchSearchExecutedEvent
		>(this.specificParameters, searchSearchExecutedParametersGlobal, globalParams, (params) => new SearchSearchExecutedEvent(params));
	}
}

/**
 * A user executed a search on global search screen.
 */
export class SearchSearchExecutedEvent extends CraftnoteEvent<SearchSearchExecutedParameters>{
  constructor(parameters: SearchSearchExecutedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "search_search_executed"
		},
		{
			name: "iterable",
			eventName: "search_search_executed"
		},
	]);
  }
}
export interface SearchItemOpenedParameters {
	version: string; // version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
	itemType: string; // the type of the item that was clicked on the global search, possible values are "project", "folder", "chat-message", "task"
	isLastInteractedItem: boolean; // whether the item that was clicked on the global search is from the last interacted item list or a search result      
}

export type SearchItemOpenedParametersSpecific = Omit<
	SearchItemOpenedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const searchItemOpenedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class SearchItemOpenedEventBuilder {
	constructor(private specificParameters: SearchItemOpenedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<SearchItemOpenedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			SearchItemOpenedParametersSpecific,
            SearchItemOpenedParameters,
			(params: SearchItemOpenedParameters) => SearchItemOpenedEvent
		>(this.specificParameters, searchItemOpenedParametersGlobal, globalParams, (params) => new SearchItemOpenedEvent(params));
	}
}

/**
 * A user clicked on one of the search results or last interacted item on global search screen.
 */
export class SearchItemOpenedEvent extends CraftnoteEvent<SearchItemOpenedParameters>{
  constructor(parameters: SearchItemOpenedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "search_item_opened"
		},
		{
			name: "iterable",
			eventName: "search_item_opened"
		},
	]);
  }
}
export interface SearchUpgradeSelectedParameters {
	version: string; // version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
}

export type SearchUpgradeSelectedParametersSpecific = Omit<
	SearchUpgradeSelectedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const searchUpgradeSelectedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class SearchUpgradeSelectedEventBuilder {
	constructor(private specificParameters: SearchUpgradeSelectedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<SearchUpgradeSelectedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			SearchUpgradeSelectedParametersSpecific,
            SearchUpgradeSelectedParameters,
			(params: SearchUpgradeSelectedParameters) => SearchUpgradeSelectedEvent
		>(this.specificParameters, searchUpgradeSelectedParametersGlobal, globalParams, (params) => new SearchUpgradeSelectedEvent(params));
	}
}

/**
 * Owner clicked on the upgrade button in the global search paywall.
 */
export class SearchUpgradeSelectedEvent extends CraftnoteEvent<SearchUpgradeSelectedParameters>{
  constructor(parameters: SearchUpgradeSelectedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "search_upgrade_selected"
		},
		{
			name: "iterable",
			eventName: "search_upgrade_selected"
		},
	]);
  }
}
